<template>
    <div class="form-group clearfix">
       <button @click.prevent="resetData" :class="['btn', 'btn-w', 'left']" v-text="lng.reset"></button>
       <button @click.prevent="saveData" :class="['btn', 'btn-w', 'right']" v-text="lng.save"></button>
    </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import axios from 'axios';
import {deepClone, createOverlay, removeOverlay} from '../../plugins/utils';
export default {
   data(){
      return {
      
      }
   },
   computed: {
    ...mapGetters(['lng', 'dataRequest'])
   },
   methods: {
        ...mapActions(['clearDataRequest', 'sendRequest']),

       resetData(){
            this.clearDataRequest();
            axios.post(url + '/vacancies', {
                action: 'resetFilter'
            }).then(response =>  {
                 location.reload(true);
            });
       },
       saveData(){
            let data = deepClone(this.dataRequest);
            delete data.action;
            delete data.page;
            createOverlay();
        axios.post(url + '/vacancies', {
            action: 'saveFilterData',
            data: data
        }).then(response => removeOverlay())
        .catch(err => removeOverlay());
       }
   }
}
</script>



// WEBPACK FOOTER //
// Buttons.vue?04a21e8e